import * as React from 'react'

import { Navigate } from 'react-router-dom'

interface Props {
  redirect?: string
}

const Redirect = ({ redirect = '/' }: Props) => <Navigate to={redirect} />

export default Redirect
